<template>
  <div class='home'>
    <ProductCategoryList
      v-show='listView'
      @newProductCategory='onClickNewFromList'
      @editProductCategory='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <ProductCategoryForm
      v-show='formView'
      :productCategory='productCategory'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import ProductCategoryList from '@/components/product-category/ProductCategoryList.vue'
import ProductCategoryForm from '@/components/product-category/ProductCategoryForm.vue'

export default {
  name: 'Product Category',
  components: {
    ProductCategoryList,
    ProductCategoryForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      productCategory: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.productCategory = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.productCategory = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.productCategory = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  }
}
</script>
